import { requestTypeTextColor } from "components/Card/RequestCard";
import DialogPDFReader from "components/Dialog/DialogPDFReader";
import useText from "constants/text";
import { useAlertDispatch } from "contexts/AlertContext";
import { ERequestType } from "generated/graphql";
import React, { useState } from "react";
import {
  AnimatedDiv,
  ContainerDetailsFile,
  ContainerPrice,
  ContainerRecapFooter,
  DetailsButton,
  RequestPrice,
} from "../MainStyles";
import { requestContainerBgColor } from "../RightSideDetails";
import { renderRequestType } from "../utils";

interface IDevisRequestQuote {
  request: any;
  type: ERequestType;
}

export default function DevisRequestQuote({ request, type }: IDevisRequestQuote) {
  const [openModalFile, setOpenModalFile] = useState(false);
  const { text } = useText();
  const dispatchAlert = useAlertDispatch();
  const openModal = () => {
    if (request?.documents && request?.documents[0]) {
      setOpenModalFile(true);
    } else {
      return dispatchAlert({
        message: text.requestQuote.error_devis_file,
        severity: "error",
      });
    }
  };
  return (
    <AnimatedDiv background-color={requestContainerBgColor[type]}>
      <ContainerRecapFooter>
        <ContainerPrice>
          <p>Total: </p>
          <RequestPrice color={requestTypeTextColor[type]}>{request?.price} XOF</RequestPrice>
        </ContainerPrice>
        <ContainerDetailsFile>
          <DetailsButton color={requestTypeTextColor[request?.type]} onClick={openModal}>
            {text.all.see_details}
          </DetailsButton>
        </ContainerDetailsFile>
      </ContainerRecapFooter>
      {openModalFile && (
        <DialogPDFReader
          open={openModalFile}
          link={request?.documents[0]?.link}
          handleClose={() => setOpenModalFile(false)}
          title={`COTATION ${renderRequestType(request?.type, text)?.toString().toUpperCase()}`}
        />
      )}
    </AnimatedDiv>
  );
}
